import React from "react";
import { motion } from "framer-motion";

const directionOffsets = {
  up: { y: 36, x: 0 },
  left: { y: 0, x: 36 },
  right: { y: 0, x: -36 },
};

export default function ScrollReveal({
  children,
  direction = "up",
  delay = 0,
  duration = 0.6,
  className = "",
  as = "div",
  once = true,
  amount = 0.2,
}) {
  const Component = motion[as] || motion.div;
  const offset = directionOffsets[direction] || directionOffsets.up;

  return (
    <Component
      className={className}
      initial={{ opacity: 0, x: offset.x, y: offset.y }}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once, amount }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Component>
  );
}
